"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { ReferencedNft } from "@/entities/IDrop";
import { ReservoirTokensResponse, ReservoirTokensResponseTokenElement } from "@/entities/IReservoir";
import { useEffect, useRef, useState } from "react";
import DropListItemContentNftDetails from "./DropListItemContentNftDetails";
import { areEqualAddresses } from "@/helpers/Helpers";
import { GRADIENT_CONTRACT, MEMELAB_CONTRACT, MEMES_CONTRACT, NEXTGEN_CONTRACT } from "@/constants";
import Link from "next/link";
import { isMemesEcosystemContract } from "@/helpers/nft.helpers";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
export default function DropListItemContentNft(t0) {
  const $ = _c(34);
  const {
    nft: t1
  } = t0;
  const {
    contract,
    token,
    name
  } = t1;
  let t2;
  let t3;
  if ($[0] !== contract || $[1] !== token) {
    t2 = [QueryKey.RESERVOIR_NFT, {
      contract,
      token
    }];
    t3 = async () => {
      const url = `https://api.reservoir.tools/tokens/v7?tokens=${contract}%3A${token}`;
      const response = await fetch(url);
      if (response.ok) {
        const data = await response.json();
        return data.tokens;
      }
      return [];
    };
    $[0] = contract;
    $[1] = token;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  const t4 = !!contract && !!token;
  let t5;
  if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
    t5 = {
      queryKey: t2,
      queryFn: t3,
      enabled: t4,
      staleTime: 300000
    };
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const {
    data: nfts
  } = useQuery(t5);
  const [nft, setNft] = useState(null);
  let t6;
  let t7;
  if ($[8] !== nfts) {
    t6 = () => {
      if (nfts?.length) {
        setNft(nfts[0]);
      }
    };
    t7 = [nfts];
    $[8] = nfts;
    $[9] = t6;
    $[10] = t7;
  } else {
    t6 = $[9];
    t7 = $[10];
  }
  useEffect(t6, t7);
  const elementRef = useRef(null);
  let t8;
  if ($[11] !== contract || $[12] !== token) {
    t8 = () => {
      if (areEqualAddresses(contract, MEMES_CONTRACT)) {
        return `/the-memes/${token}`;
      }
      if (areEqualAddresses(contract, GRADIENT_CONTRACT)) {
        return `/6529-gradient/${token}`;
      }
      if (areEqualAddresses(contract, NEXTGEN_CONTRACT)) {
        return `/nextgen/token/${token}`;
      }
      if (areEqualAddresses(contract, MEMELAB_CONTRACT)) {
        return `/memelab/${token}`;
      }
      return `https://opensea.io/assets/ethereum/${contract}/${token}`;
    };
    $[11] = contract;
    $[12] = token;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const getNftHref = t8;
  let t9;
  if ($[14] !== contract) {
    t9 = () => {
      const isMemes = isMemesEcosystemContract(contract);
      if (isMemes) {
        return "";
      }
      return "_blank";
    };
    $[14] = contract;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const getTarget = t9;
  const nftHref = getNftHref();
  const target = getTarget();
  let t10;
  if ($[16] !== nft) {
    t10 = nft && <img src={nft.token.imageLarge} alt="NFT token" className="tw-w-full tw-h-full tw-object-center tw-object-contain" />;
    $[16] = nft;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10) {
    t11 = <div className="tw-w-full tw-h-64">{t10}</div>;
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== contract || $[21] !== name || $[22] !== token) {
    t12 = {
      contract,
      token,
      name
    };
    $[20] = contract;
    $[21] = name;
    $[22] = token;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== nft || $[25] !== t12) {
    t13 = <DropListItemContentNftDetails referencedNft={t12} nft={nft} />;
    $[24] = nft;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t11 || $[28] !== t13) {
    t14 = <div className="tw-mt-2 tw-gap-y-2 tw-flex tw-flex-col" ref={elementRef}>{t11}{t13}</div>;
    $[27] = t11;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== nftHref || $[31] !== t14 || $[32] !== target) {
    t15 = <Link onClick={_temp} href={nftHref} className="tw-no-underline" target={target}>{t14}</Link>;
    $[30] = nftHref;
    $[31] = t14;
    $[32] = target;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  return t15;
}
function _temp(e) {
  return e.stopPropagation();
}